<template>
  <div class="containers">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('notifications.many'), name: 'all_notifications' },
            { text: $t('notifications.addChannel') },
          ]"
        />
      </template>
    </SectionHeader>

    <div class="body-content">
      <div class="entries-wrap">
        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('notifications.createChannel') }}</h3>
          </header>
          <div class="content-body">
            <Form v-model="notification_channel" @submit="createChannel" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from '@/views/notifications/channels/Form.vue'

import BreadCrumbs from '@/components/BreadCrumbs'
import SectionHeader from '@/components/SectionHeader'

import notificationChannelsApi from '@/api/notificationChannels'

export default {
  name: 'new_notification_channel',
  inject: ['companyUser'],
  components: { BreadCrumbs, SectionHeader, Form },
  data: () => ({
    notification_channel: {
      email: '',
    },
  }),
  methods: {
    createChannel: async function (channel) {
      const response = await notificationChannelsApi.create({
        company_uuid: this.companyUser.company_uuid,
        ...channel,
      })

      if (response.success) {
        await this.$router.push('/notifications')
      }
    },
  },
}
</script>

<style lang="scss"></style>
